import * as React from 'react';

import { Button } from '@material-ui/core';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { clientConfig } from 'config/client';

import { LoginAuth } from './LoginAuth';
import { IMockLoginValues, IProps } from './LoginPage.types';

import Logo from '../../../images/logo.svg';
import styles from './LoginPage.module.styl';

export class LoginPageRaw extends React.Component<IProps> {
  public componentDidMount(): void {
    const { withoutRedirect } = this.props;

    if (withoutRedirect) {
      this.props.history.replace(`/`);
      return;
    }

    const { pathname = '', search = '', hash = '' } = this.props.location;

    if (!this.getRedirect()) {
      this.props.history.replace(
        `/?redirect=${btoa(pathname + search + hash)}`,
      );
    }
  }

  public render() {
    const { error } = this.props;

    return (
      <div className={styles.root}>
        <img alt="logo" src={Logo} className={styles.loginLogo} />

        <div className={styles.loginForm}>
          <h1>
            Welcome
            <br /> to your intranet Inside AUTO1
          </h1>

          {clientConfig.mockLogin ? (
            <LoginAuth
              onSubmit={this.handleMockLogin}
              additionalButtons={this.renderGoogleLoginButton()}
            />
          ) : (
            this.renderGoogleLoginButton()
          )}
          {error && <p className={styles.error}>{error}</p>}
        </div>
      </div>
    );
  }

  private readonly renderGoogleLoginButton = () => (
    <Button
      type="button"
      className={styles.newLoginButton}
      variant="contained"
      onClick={this.handleGoogleLogin}
    >
      Log in
    </Button>
  );

  private readonly handleGoogleLogin = () => {
    window.location.replace(
      `${clientConfig.apiPath}/auth/google?state=${this.getRedirect()}`,
    );
  };

  private readonly handleMockLogin = async (values: IMockLoginValues) => {
    window.location.replace(
      `${
        window.location.origin
      }/login?redirect=${this.getRedirect()}&mock=true&code=${values.username}`,
    );
  };

  private readonly getRedirect = () => {
    const { search } = window.location;

    const queryParams = qs.parse(search, { ignoreQueryPrefix: true });

    return queryParams.redirect;
  };
}

const LoginPage = withRouter(LoginPageRaw);

export { LoginPage };
